//#region IMPORT
import React, { useRef } from 'react';
/** Components Import */
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import 'swiper/css';
import Icon from '../../../Assets/Icon/CustomIcon';
import PerButton from '../../Permit/ui/PerButton';
import { useOutletContext } from 'react-router-dom';
import BackClickBottomSheet from '../../Permit/ui/BackClickBottomSheet';
import InputText from '../ui/InputText';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { CommonActions } from '../../../Reducer/CommonReducer';
import { useDispatch, useSelector } from 'react-redux';
import { BottomSheetActions } from '../../../Reducer/BottomSheetReducer';
//#endregion

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

function M_WOE_BASIC_01(props) {
  //#region 변수
  const { ToggleDrawer } = useOutletContext();
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();
  const bottomSheetState = useSelector((state) => state.bottomSheet);

  const workInfoFields = [
    {
      name: 'beforeComment',
      label: '내용',
      placeholder: '내용을 입력하세요.',
      error: props.errors.beforeComment,
    },
  ];
  //#endregion

  return (
    <Box sx={{ px: 2 }}>
      <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
        작업 종료
        <br />
        작성을 시작할게요.
      </p>
      <p style={{ fontSize: '16px', color: '#939393' }}>
        아래 사항들을 작성해주세요.
      </p>

      <Box sx={{ display: 'flex', gap: 1, my: 2 }}>
        <Box>
          <button
            style={{
              cursor: 'pointer',
              border: '1px solid #DFD9D9',
              borderRadius: '8px',
              color: '#8D8787',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '14px',
              padding: '8px 16px',
              width: '90px',
              height: '92px',
            }}
            onClick={() => {
              fileInputRef.current?.click();
            }}
          >
            <Icon.Camera width={40} height={40} />
            <p>{props.previewList.filter((img) => !img.deleted).length} / 5</p>
          </button>
          <VisuallyHiddenInput
            ref={fileInputRef}
            type="file"
            accept="image/*"
            onChange={props.FileChange}
          />
        </Box>

        {/* 썸네일 목록 */}
        <Box sx={{ flex: 1, width: '100%', overflow: 'hidden' }}>
          <Swiper slidesPerView="auto" spaceBetween={8}>
            {props.previewList
              .filter((img) => !img.deleted)
              .map((item, index) => (
                <SwiperSlide className="workinfo-slide" key={index}>
                  <Box
                    sx={{
                      position: 'relative',
                      width: '90px',
                      height: '92px',
                      border: '1px solid #DFD9D9',
                      borderRadius: '8px',
                      overflow: 'hidden',
                    }}
                  >
                    <img
                      style={{
                        width: '100%',
                        objectFit: 'cover',
                      }}
                      src={item.preview}
                      alt="img"
                    />
                    <button
                      style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        border: 'none',
                        backgroundColor: 'transparent',
                        cursor: 'pointer',
                      }}
                      onClick={() => props.DeletePreview(item)}
                    >
                      <Icon.Delete width={20} height={20} />
                    </button>
                  </Box>
                </SwiperSlide>
              ))}
          </Swiper>
        </Box>
      </Box>

      <Box sx={{ mb: 2 }}>
        <Box>
          {workInfoFields.map((field) => (
            <InputText
              key={field.name}
              label={field.label}
              value={props.workEndInputs[field.name] || ''}
              onChange={(e) =>
                props.setWorkEndInputs({
                  ...props.workEndInputs,
                  [field.name]: e.target.value,
                })
              }
              placeholder={field.placeholder}
              error={field.error}
              setError={props.setErrors}
              maxLength={
                field.name === 'title'
                  ? 100
                  : field.name === 'content'
                  ? 1000
                  : undefined
              }
            />
          ))}
        </Box>
      </Box>

      <PerButton
        saveText={'저장'}
        onCancel={() =>
          dispatch(
            BottomSheetActions.SetBottomSheetState({
              bottom: true,
              type: 'backClickWor',
            })
          )
        }
        onClick={() => {
          if (props.ValidateAll()) {
            props.SaveLogic1();
          }
        }}
      />

      {/* 바텀시트 */}
      {bottomSheetState.bottom && bottomSheetState.type === 'backClickWor' && (
        <BackClickBottomSheet
          open={true}
          ToggleDrawer={ToggleDrawer}
          route={'/Home'}
          onSubmit={() => {
            dispatch(CommonActions.setActiveStep(0));
          }}
        />
      )}
    </Box>
  );
}

export default M_WOE_BASIC_01;
